import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { customersApiService } from '../../services';

function Dispatch({ tabColors = { bgcolor: 'bg-greenDispatch', nocolor: 'bg-green-100', hovercolor: 'hover:bg-green-200' } }) {
  const { id } = useParams();

  // Form state
  const [formData, setFormData] = useState({
    surveyUrl: 'https://survey.zohopublic.com/zs/LtC2E6',
    surveyUrlEditable: false,
    ipfoneEquipment: '',
    ticketNumber: '',
    accountNumber: '',
    companyName: '',
    companyAddress: '',
    contactName: '',
    contactNumber: '',
    regularHours: '9 to 5',
    regularHoursEditable: false,
    emergenciesHours: '( only for Emergency dispatches)',
    techRequestingDispatch: 'Daniel Urra',
    techEditable: false,
    pbxPlatform: '',
    server: '',
    phoneMAC: '',
    phoneLinePort: '',
    networksProvider: '',
    networksServiceSpeeds: '',
    networkWAN: '',
    networkLAN: '',
    emRouter: '',
    version: '',
    model: '2900e',
    modelEditable: false,
    linePort: '',
    description: '',
  });

  const [previewContent, setPreviewContent] = useState('');
  const [clipboardMessage, setClipboardMessage] = useState('');

  const handleInputChange = e => {
    const { id, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [id]: type === 'checkbox' ? checked : value,
    }));
  };

  const updatePreview = useCallback(() => {
    let preview = '';

    preview += `<strong>Survey:</strong> ${formData.surveyUrl}<br>`;
    preview += `<strong>IPFone Equipment Required:</strong> ${formData.ipfoneEquipment}<br>`;
    preview += `<strong>Ticket Number:</strong> ${formData.ticketNumber}<br>`;
    preview += `<strong>Account Number:</strong> ${formData.accountNumber}<br>`;
    preview += `<strong>Company name:</strong> ${formData.companyName}<br>`;
    preview += `<strong>Company address:</strong> ${formData.companyAddress}<br>`;
    preview += `<strong>Contact name:</strong> ${formData.contactName}<br>`;
    preview += `<strong>Contact Number:</strong> ${formData.contactNumber}<br>`;
    preview += `<strong>Hours of operation:</strong> ${formData.regularHours}<br>`;
    preview += `<strong>What time can they stay until for Emergencies:</strong> ${formData.emergenciesHours}<br>`;
    preview += `<strong>Tech requesting dispatch:</strong> ${formData.techRequestingDispatch}<br>`;
    preview += `<strong>PBX Platform:</strong> ${formData.pbxPlatform}<br>`;
    preview += `<strong>Server( if applicable ):</strong> ${formData.server}<br>`;
    preview += `<strong>Phone MAC:</strong> ${formData.phoneMAC}<br>`;
    preview += `<strong>Phone Lineport:</strong> ${formData.phoneLinePort}<br>`;
    preview += `<strong>Networks provider:</strong> ${formData.networksProvider}<br>`;
    preview += `<strong>Networks Service Speeds:</strong> ${formData.networksServiceSpeeds}<br>`;
    preview += `<strong>Network WAN IP address:</strong> ${formData.networkWAN}<br>`;
    preview += `<strong>Network LAN IP address:</strong> ${formData.networkLAN}<br>`;
    preview += `<strong>EM/Router:</strong> ${formData.emRouter}<br>`;
    preview += `<strong>version:</strong> ${formData.version}<br>`;
    preview += `<strong>model:</strong> ${formData.model}<br>`;
    preview += `<strong>Line/Port:</strong> ${formData.linePort}<br>`;
    preview += `<br><strong>Description in detail of the problem:</strong><br>${formData.description.replace(/\n/g, '<br>')}`;

    setPreviewContent(preview);
  }, [formData]);

  // Update page title when ticket is loaded
  useEffect(() => {
    console.log('[DISPATCH] useEffect triggered with id:', id);
    if (id) {
      console.log('[DISPATCH] Fetching ticket data for ID:', id);
      customersApiService
        .getTicketById(id)
        .then(async data => {
          console.log('[DISPATCH] Ticket data received:', data);
          // Fetch fresh customer data to avoid stale cached names
          let customerName = data.customer_name;
          let pbxPlatform = '';
          let serverOrEnterprise = '';

          try {
            console.log('[DISPATCH] Fetching customer data for number:', data.customer_number);
            const customer = await customersApiService.getCustomerByNumber(data.customer_number);
            console.log('[DISPATCH] Customer data received:', customer);
            console.log('[DISPATCH] Customer platform value:', customer.platform);
            console.log('[DISPATCH] Customer server value:', customer.server);
            console.log('[DISPATCH] Customer enterprise value:', customer.enterprise);

            if (customer) {
              if (customer.customer_name) {
                customerName = customer.customer_name;
              }

              // Set PBX Platform from customer data
              if (customer.platform) {
                // Capitalize first letter of platform
                pbxPlatform = customer.platform.charAt(0).toUpperCase() + customer.platform.slice(1);
                console.log('[DISPATCH] PBX Platform set to:', pbxPlatform);
              }

              // Set Server or Enterprise based on platform
              if (customer.platform === 'bicom' && customer.server) {
                serverOrEnterprise = customer.server;
                console.log('[DISPATCH] Server (Bicom) set to:', serverOrEnterprise);
              } else if (customer.platform === 'broadsoft' && customer.enterprise) {
                serverOrEnterprise = customer.enterprise;
                console.log('[DISPATCH] Server (Broadsoft/Enterprise) set to:', serverOrEnterprise);
              }

              console.log('[DISPATCH] Final values - PBX Platform:', pbxPlatform, 'Server:', serverOrEnterprise);
            }
          } catch (err) {
            console.warn('[DISPATCH] Could not fetch fresh customer data, using cached name:', err);
          }

          const pageTitle = `${data.ticket_number} - ${customerName} - ${data.issue_with}`;
          document.title = pageTitle;

          // Pre-fill form with ticket data
          console.log('[DISPATCH] Setting form data with pbxPlatform:', pbxPlatform, 'server:', serverOrEnterprise);
          setFormData(prev => ({
            ...prev,
            ticketNumber: data.ticket_number || '',
            accountNumber: data.customer_number || '',
            companyName: customerName || '',
            techRequestingDispatch: data.full_name || 'Daniel Urra',
            pbxPlatform: pbxPlatform,
            server: serverOrEnterprise,
          }));
        })
        .catch(err => {
          console.error('[DISPATCH] Error fetching ticket:', err);
          document.title = 'SSK - Support Swiss Knife';
        });
    } else {
      console.log('[DISPATCH] No ticket ID available');
      document.title = 'SSK - Support Swiss Knife';
    }

    return () => {
      document.title = 'SSK - Support Swiss Knife';
    };
  }, [id]);

  // Update preview whenever form data changes
  useEffect(() => {
    updatePreview();
  }, [formData, updatePreview]);

  const generateFile = () => {
    let content = '';

    content += `Survey: ${formData.surveyUrl}\n`;
    content += `IPFone Equipment Required: ${formData.ipfoneEquipment}\n`;
    content += `Ticket Number: ${formData.ticketNumber}\n`;
    content += `Account Number: ${formData.accountNumber}\n`;
    content += `Company name: ${formData.companyName}\n`;
    content += `Company address: ${formData.companyAddress}\n`;
    content += `Contact name: ${formData.contactName}\n`;
    content += `Contact Number: ${formData.contactNumber}\n`;
    content += `Hours of operation: ${formData.regularHours}\n`;
    content += `What time can they stay until for Emergencies: ${formData.emergenciesHours}\n`;
    content += `Tech requesting dispatch: ${formData.techRequestingDispatch}\n`;
    content += `PBX Platform: ${formData.pbxPlatform}\n`;
    content += `Server( if applicable ): ${formData.server}\n`;
    content += `Phone MAC: ${formData.phoneMAC}\n`;
    content += `Phone Lineport: ${formData.phoneLinePort}\n`;
    content += `Networks provider: ${formData.networksProvider}\n`;
    content += `Networks Service Speeds: ${formData.networksServiceSpeeds}\n`;
    content += `Network WAN IP address: ${formData.networkWAN}\n`;
    content += `Network LAN IP address: ${formData.networkLAN}\n`;
    content += `EM/Router: ${formData.emRouter}\n`;
    content += `version: ${formData.version}\n`;
    content += `model: ${formData.model}\n`;
    content += `Line/Port: ${formData.linePort}\n`;
    content += `\nDescription in detail of the problem:\n${formData.description}`;

    try {
      const blob = new Blob([content], { type: 'text/plain' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'dispatch-details.txt';
      link.click();
    } catch (error) {
      console.error('Error generating file:', error);
    }
  };

  const copyDispatchToClipboard = () => {
    // Remove <strong> tags and their content
    let cleanedContent = previewContent.replace(/<\/?strong[^>]*>/gi, '');
    // Replace <br> tags with newline characters
    let formattedContent = cleanedContent.replace(/<br\s*\/?>/gi, '\n');

    navigator.clipboard
      .writeText(formattedContent)
      .then(() => {
        setClipboardMessage('Dispatch details copied to clipboard!');
        setTimeout(() => {
          setClipboardMessage('');
        }, 5000);
      })
      .catch(err => {
        console.error('Failed to copy: ', err);
      });
  };

  const clearForm = () => {
    setFormData({
      surveyUrl: 'https://survey.zohopublic.com/zs/LtC2E6',
      surveyUrlEditable: false,
      ipfoneEquipment: '',
      ticketNumber: '',
      accountNumber: '',
      companyName: '',
      companyAddress: '',
      contactName: '',
      contactNumber: '',
      regularHours: '9 to 5',
      regularHoursEditable: false,
      emergenciesHours: '( only for Emergency dispatches)',
      techRequestingDispatch: 'Daniel Urra',
      techEditable: false,
      pbxPlatform: '',
      server: '',
      phoneMAC: '',
      phoneLinePort: '',
      networksProvider: '',
      networksServiceSpeeds: '',
      networkWAN: '',
      networkLAN: '',
      emRouter: '',
      version: '',
      model: '2900e',
      modelEditable: false,
      linePort: '',
      description: '',
    });
  };

  return (
    <div id="tab7">
      <div className="flex">
        {/* Left Side - Form */}
        <div className="w-1/2 p-6 bg-green-tabs-200">
          <h1 className="text-2xl font-bold mb-6 text-gray-800">
            Tech Dispatch Form
          </h1>

          <form id="issueForm" className="space-y-4">
            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Survey:
              </h3>
              <input
                type="text"
                id="surveyUrl"
                value={formData.surveyUrl}
                onChange={handleInputChange}
                disabled={!formData.surveyUrlEditable}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                required
              />
              <input
                type="checkbox"
                id="surveyUrlEditable"
                checked={formData.surveyUrlEditable}
                onChange={handleInputChange}
              />
              <label htmlFor="surveyUrlEditable" className="text-gray-600">
                Edit
              </label>
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                IPFone Equipment Required:
              </h3>
              <input
                type="text"
                id="ipfoneEquipment"
                value={formData.ipfoneEquipment}
                onChange={handleInputChange}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Ticket Number:
              </h3>
              <input
                type="text"
                id="ticketNumber"
                value={formData.ticketNumber}
                onChange={handleInputChange}
                placeholder="EMXXXXXX"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Account Number:
              </h3>
              <input
                type="text"
                id="accountNumber"
                value={formData.accountNumber}
                onChange={handleInputChange}
                placeholder="88899999"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Company name:
              </h3>
              <input
                type="text"
                id="companyName"
                value={formData.companyName}
                onChange={handleInputChange}
                placeholder="ACME COMPANY LLC"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Company address:
              </h3>
              <input
                type="text"
                id="companyAddress"
                value={formData.companyAddress}
                onChange={handleInputChange}
                placeholder="728 Main Street, Union City, NJ, 318200"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Contact name:
              </h3>
              <input
                type="text"
                id="contactName"
                value={formData.contactName}
                onChange={handleInputChange}
                placeholder="John Smith"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Contact Number:
              </h3>
              <input
                type="text"
                id="contactNumber"
                value={formData.contactNumber}
                onChange={handleInputChange}
                placeholder="7860000000"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Hours of operation:
              </h3>
              <input
                type="text"
                id="regularHours"
                value={formData.regularHours}
                onChange={handleInputChange}
                placeholder="9 to 5"
                disabled={!formData.regularHoursEditable}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                required
              />
              <input
                type="checkbox"
                id="regularHoursEditable"
                checked={formData.regularHoursEditable}
                onChange={handleInputChange}
              />
              <label htmlFor="regularHoursEditable" className="text-gray-600">
                Edit
              </label>
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-blue-600">
                What time can they stay until for Emergencies:
              </h3>
              <input
                type="text"
                id="emergenciesHours"
                value={formData.emergenciesHours}
                onChange={handleInputChange}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Tech requesting dispatch:
              </h3>
              <input
                type="text"
                id="techRequestingDispatch"
                value={formData.techRequestingDispatch}
                onChange={handleInputChange}
                disabled={!formData.techEditable}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                required
              />
              <input
                type="checkbox"
                id="techEditable"
                checked={formData.techEditable}
                onChange={handleInputChange}
              />
              <label htmlFor="techEditable" className="text-gray-600">
                Edit
              </label>
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                PBX Platform:
              </h3>
              <input
                type="text"
                id="pbxPlatform"
                value={formData.pbxPlatform}
                onChange={handleInputChange}
                placeholder="Broadsoft / Bicom"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Server( if applicable ):
              </h3>
              <input
                type="text"
                id="server"
                value={formData.server}
                onChange={handleInputChange}
                placeholder="EPBX / ENT"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Phone MAC:
              </h3>
              <input
                type="text"
                id="phoneMAC"
                value={formData.phoneMAC}
                onChange={handleInputChange}
                placeholder="Enter Phone MAC"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Phone Lineport:
              </h3>
              <input
                type="text"
                id="phoneLinePort"
                value={formData.phoneLinePort}
                onChange={handleInputChange}
                placeholder="Enter Phone Lineport:"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Networks provider:
              </h3>
              <input
                type="text"
                id="networksProvider"
                value={formData.networksProvider}
                onChange={handleInputChange}
                placeholder="Comcast, ATT, FPL, Nitel, etc."
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Networks Service Speeds:
              </h3>
              <input
                type="text"
                id="networksServiceSpeeds"
                value={formData.networksServiceSpeeds}
                onChange={handleInputChange}
                placeholder="Symetric 100/100, 200/200, 500/500, etc."
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Network WAN IP address:
              </h3>
              <input
                type="text"
                id="networkWAN"
                value={formData.networkWAN}
                onChange={handleInputChange}
                placeholder="Enter Network WAN IP address"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Network LAN IP address:
              </h3>
              <input
                type="text"
                id="networkLAN"
                value={formData.networkLAN}
                onChange={handleInputChange}
                placeholder="Enter Network LAN IP address"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                EM/Router:
              </h3>
              <input
                type="text"
                id="emRouter"
                value={formData.emRouter}
                onChange={handleInputChange}
                placeholder="Enter EM IP Address"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                version:
              </h3>
              <input
                type="text"
                id="version"
                value={formData.version}
                onChange={handleInputChange}
                placeholder="EM firmware version"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                model:
              </h3>
              <input
                type="text"
                id="model"
                value={formData.model}
                onChange={handleInputChange}
                disabled={!formData.modelEditable}
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                required
              />
              <input
                type="checkbox"
                id="modelEditable"
                checked={formData.modelEditable}
                onChange={handleInputChange}
              />
              <label htmlFor="modelEditable" className="text-gray-600">
                Edit
              </label>
            </div>

            <div className="flex items-center gap-4">
              <h3 className="w-1/3 text-nowrap font-bold text-gray-700">
                Line/Port:
              </h3>
              <input
                type="text"
                id="linePort"
                value={formData.linePort}
                onChange={handleInputChange}
                placeholder="Enter Line/Port"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                required
              />
            </div>
          </form>
        </div>

        {/* Right Side - Description and Preview */}
        <div className="w-1/2 p-6 bg-green-tabs-200">
          <h2 className="text-xl font-bold mb-4 text-gray-800">
            Description in detail of the problem:
          </h2>
          <textarea
            id="description"
            value={formData.description}
            onChange={handleInputChange}
            rows="10"
            placeholder="Enter your text here..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>

          <div className="p-6 bg-white rounded-lg shadow-md w-full mt-4">
            <h2 className="text-xl font-bold mb-4">Preview</h2>
            <div
              contentEditable
              className="w-full p-4 border border-gray-300 rounded-md shadow-md bg-gray-50"
              dangerouslySetInnerHTML={{ __html: previewContent }}
            ></div>
          </div>

          <div className="flex flex-wrap items-center gap-4 mt-6">
            <button
              type="button"
              className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white font-medium rounded-md shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
              onClick={copyDispatchToClipboard}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184"
                />
              </svg>
              Copy to Clipboard
            </button>

            <button
              type="button"
              className="px-4 py-2 bg-green-600 text-white font-medium rounded-md shadow-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
              onClick={generateFile}
            >
              Generate TXT File
            </button>

            <button
              type="button"
              className="px-4 py-2 bg-red-600 text-white font-medium rounded-md shadow-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500"
              onClick={clearForm}
            >
              Clear All
            </button>
          </div>

          {clipboardMessage && (
            <div className="text-green-600 mt-4 font-medium">
              {clipboardMessage}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Dispatch;
